// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"193":"3ddf50e0","1275":"e1129332","1365":"00b7e472","6780":"17864a8c"}[chunkId] + ".chunk.css";
};